// Ostatnio oglądany pulpit - wygoda tego telefonu (start APP wraca do niego, jak stara APP). Pamięć przeglądarki może
// być pusta albo zablokowana (tryb prywatny) - wtedy start wybiera pulpit sam.
const KLUCZ = "iot-pulpit";

/** Pulpit sztuki w sekcji „Pulpit” (start, wybór w górnym pasku) - z listy urządzeń ten sam ekran jest pod `/urzadzenia/:sn`. */
export function sciezkaPulpituSztuki(sn: string): string {
  return "/pulpit/urzadzenie/" + encodeURIComponent(sn);
}

export function zapamietaj(sciezka: string): void {
  try {
    localStorage.setItem(KLUCZ, sciezka);
  } catch {
    // brak pamięci - start bez zapamiętanego pulpitu
  }
}

/** Wylogowanie: następne konto nie startuje na pulpicie poprzedniego (jego sztuki nie ma na nowym koncie). */
export function zapomnijPulpit(): void {
  try {
    localStorage.removeItem(KLUCZ);
  } catch {
    // brak pamięci - nie było czego zapomnieć
  }
}

export function ostatni(): string | null {
  try {
    return localStorage.getItem(KLUCZ);
  } catch {
    return null;
  }
}

/** Ostatnio oglądany pulpit własny (`/pulpit/<id>`), a bez niego pierwszy własny. */
export function ostatniWlasny<P extends { id: number }>(pulpity: readonly P[]): P | undefined {
  const id = Number(/^\/pulpit\/(\d+)$/.exec(ostatni() ?? "")?.[1] ?? 0);
  return pulpity.find((p) => p.id === id) ?? pulpity[0];
}
